import { render } from "./Journal.vue?vue&type=template&id=0ba3798d&scoped=true"
import script from "./Journal.vue?vue&type=script&lang=js"
export * from "./Journal.vue?vue&type=script&lang=js"

import "./Journal.vue?vue&type=style&index=0&id=0ba3798d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba3798d"]])

export default __exports__